import {Box, IconButton, styled, Typography} from "@mui/material";
import React, {useRef, useState} from "react";
import roadmapBackground from "../../assets/roadmapBackground.png";
import {reports, roadmap} from "../../config/roadmap";
import FileButton from "../TopSection/FileButton";
import RoadmapEl from "./RoadmapEl";
import RoadmapReportEl from "./RoadmapReportEl";
import ArrowForwardIosIcon from "@mui/icons-material/ArrowForwardIos";
import ArrowBackIosNewIcon from "@mui/icons-material/ArrowBackIosNew";

// eslint-disable-next-line @typescript-eslint/no-var-requires
const file = require("../../files/Insight_Questor_Roadmap.xlsx");
// eslint-disable-next-line @typescript-eslint/no-var-requires
const filePDF = require("../../files/Insight_Questor_Roadmap.pdf");

const RoadmapContainer = styled(Box)({
    width: "100%",
    position: "relative",
    borderImage: "linear-gradient(90deg, #05080c, #6d7985, #05080c) 100",
    borderBottom: "2px solid",
    background: `linear-gradient(rgba(0, 0, 0, 0.6), rgba(0, 0, 0, 0.3)), url(${roadmapBackground}) no-repeat center 100%`,
    backgroundSize: "cover",
    padding: "10px 20px",
    boxSizing: "border-box",
    "@media(max-width: 768px)":{
        backgroundSize: "cover",
    }
});

const RoadmapHeader = styled(Box)({
    display: "flex",
    justifyContent: "space-between",
    alignItems: "center"
});

const RoadmapContentContainer = styled(Box)({
    overflow: "auto"
});

const RoadmapTitle = styled(Typography)({
    fontSize: "3.5rem",
    fontWeight: 400,
    color: "#FFFFFF",
    zIndex: 2,
    textShadow: "1px 1px 2px black, 0 0 25px black, 0 0 5px black",
    "@media(max-width: 768px)":{
        fontSize: "1.8rem",
    }
});

const RoadmapYearsContainer = styled(Box)({
    marginTop: "20px",
    minWidth: "7000px",
    width: "auto",
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    columnGap: "50px",
    "@media(max-width: 768px)":{
        minWidth: "3500px",
    }
});

const RoadmapElementsContainer = styled(Box)({
    display: "grid",
    padding: "20px",
    rowGap: "60px",
    gridTemplateRows: "1fr 1fr",
});

const RoadmapElementsContainerRow = styled(Box)({
    display: "grid",
    gridTemplateColumns: "1fr 1fr 1fr",
    columnGap: "100px",
});

const RoadmapYearTitle = styled(Box)({
    position: "relative",
    fontSize: "1.2rem",
    fontWeight: 400,
    color: "#ffc371",
    zIndex: 2,
    textAlign: "center",
    textShadow: "1px 1px 2px black, 0 0 15px #ff5f6d, 0 0 5px #ff5f6d",
    borderBottom: "1px solid #ff5f6d",
    "& p":{
        fontSize: "1.1rem",
        fontWeight: 600,
    },
    "&:before":{
        content: "' '",
        position: "absolute",
        height: "20px",
        width: "1px",
        background: "#ff5f6d",
        left: 0,
        bottom: "-20px",
    },
    "&:after":{
        content: "' '",
        position: "absolute",
        height: "20px",
        width: "1px",
        background: "#ff5f6d",
        right: 0,
        bottom: "-20px",
    },
    "@media(max-width: 768px)":{
        fontSize: "1rem",
        "& p":{
            fontSize: "0.8rem",
        },
    }
});

const RoadmapReportsContainer = styled(Box)({
    minWidth: "7000px",
    width: "auto",
    display: "grid",
    gridTemplateColumns: "3fr 3fr 3fr 2fr 1fr 3fr 3fr 2fr",
    columnGap: "10px",
    marginBottom: "20px",
    "@media(max-width: 768px)":{
        minWidth: "3500px",
    }
});

const ButtonTo = styled(IconButton)({
    padding: "15px",
    background: "rgba(0, 0, 0, 0.8)",
    position: "absolute",
    zIndex: 20,
    top: "calc(50% - 4.5px)",
    right: "20px",
    transition: "all .3s ease",
    "&.left":{
        left: "20px",
        right: "auto",
    },
    "&:hover":{
        transform: "scale(1.1)",
        background: "rgba(0, 0, 0, 0.6)",
    }
});
const Roadmap = ():JSX.Element => {
    
    const scrollRef = useRef(null);
    
    const [showRightButton, setShowRightButton] = useState<boolean>(true);
    const [showLeftButton, setShowLeftButton] = useState<boolean>(false);
    
    const handleScrollEvent = (e: React.UIEvent<HTMLDivElement>):void => {
        const positionScroll = e.currentTarget.scrollLeft || 0;
        const scrollWidth = e.currentTarget.scrollWidth || 0;
        setShowRightButton((positionScroll + window.innerWidth) < scrollWidth);
        setShowLeftButton(positionScroll !== 0);
    };
    
    const handleToRight = ():void => {
        // eslint-disable-next-line
        const positionScroll = (scrollRef.current as any)?.scrollLeft || 0;
        // eslint-disable-next-line
        (scrollRef.current as any).scrollTo(positionScroll + 1000, 0);
    };
    
    const handleToLeft = ():void => {
        // eslint-disable-next-line
        const positionScroll = (scrollRef.current as any)?.scrollLeft || 0;
        // eslint-disable-next-line
        (scrollRef.current as any).scrollTo(positionScroll - 1000, 0);
    };
    
    const renderRightButton = ():React.ReactNode | null => {
        if(showRightButton) {
            return <ButtonTo onClick={handleToRight}>
                <ArrowForwardIosIcon htmlColor={"#FFFFFF"}/>
            </ButtonTo>;
        }
        return null;
    };
    
    const renderLeftButton = ():React.ReactNode | null => {
        if(showLeftButton) {
            return <ButtonTo className={"left"} onClick={handleToLeft}>
                <ArrowBackIosNewIcon htmlColor={"#FFFFFF"}/>
            </ButtonTo>;
        }
        return null;
    };
    
    return (
        <RoadmapContainer id={"roadmap"}>
            <RoadmapHeader>
                <RoadmapTitle>Roadmap:</RoadmapTitle>
                {window.innerWidth > 768 && <FileButton title={"Roadmap Table"} file={file} fileTitle={"Insight_Questor_Roadmap"} filePdf={filePDF} size={"small"} noRightSpace={true} />}
            </RoadmapHeader>
            <RoadmapContentContainer ref={scrollRef} onScroll={handleScrollEvent}>
                {renderRightButton()}
                {renderLeftButton()}
                <RoadmapYearsContainer>
                    <Box>
                        <RoadmapYearTitle>
                        Year 1: Initial Development & Alpha Version (Months 1-12)
                            <p>
                            Budget: ≈ €3,500,000
                            </p>
                        </RoadmapYearTitle>
                        <RoadmapElementsContainer>
                            <RoadmapElementsContainerRow>
                                {roadmap.firstYear.filter(({top}) => !!top).map((opt, index) => <RoadmapEl
                                    key={"firstYear-roadmapEl-" + index}
                                    top={opt.top}
                                    title={opt.title}
                                    points={opt.points}/>)}
                            </RoadmapElementsContainerRow>
                            <RoadmapElementsContainerRow sx={{
                                transform: "translateX(17.5%)"
                            }}>
                                {roadmap.firstYear.filter(({top}) => !top).map((opt, index) => <RoadmapEl
                                    key={"secondYear-roadmapElBottom-" + index}
                                    top={opt.top}
                                    title={opt.title}
                                    points={opt.points}/>)}
                            </RoadmapElementsContainerRow>
                        </RoadmapElementsContainer>
                    </Box>
                    <Box>
                        <RoadmapYearTitle>
                            Year 2: Feature Expansion & Full Launch (Months 12-24)
                            <p>
                                Budget: ≈ €4,500,000
                            </p>
                        </RoadmapYearTitle>
                        <RoadmapElementsContainer>
                            <RoadmapElementsContainerRow
                                sx={{
                                    transform: "translateX(17.5%)"
                                }}
                            >
                                {roadmap.secondYear.filter(({top}) => !!top).map((opt, index) => <RoadmapEl
                                    key={"secondYear-roadmapEl-" + index}
                                    top={opt.top}
                                    title={opt.title}
                                    points={opt.points}/>)}
                            </RoadmapElementsContainerRow>
                            <RoadmapElementsContainerRow >
                                {roadmap.secondYear.filter(({top}) => !top).map((opt, index) => <RoadmapEl
                                    key={"secondYear-roadmapElBottom-" + index}
                                    top={opt.top}
                                    title={opt.title}
                                    points={opt.points}/>)}
                            </RoadmapElementsContainerRow>
                        </RoadmapElementsContainer>
                    </Box>
                    <Box>
                        <RoadmapYearTitle>
                            Year 3: Early Growth Stage (≈ Months 24-36)
                            <p>
                                Budget: ≈ €4,500,000
                            </p>
                        </RoadmapYearTitle>
                        <RoadmapElementsContainer sx={{
                            overflow: "hidden"
                        }}>
                            <RoadmapElementsContainerRow
                                sx={{
                                    "& i": {
                                        display: "none"
                                    }
                                }}
                            >
                                {roadmap.thirdYear.filter(({top}) => !!top).map((opt, index) => <RoadmapEl
                                    key={"thirdYear-roadmapEl-" + index}
                                    top={opt.top}
                                    title={opt.title}
                                    points={opt.points}/>)}
                            </RoadmapElementsContainerRow>
                            <RoadmapElementsContainerRow sx={{
                                transform: "translateX(17.5%)",
                                "& i": {
                                    left: "-44%",
                                    "@media(max-width: 768px)":{
                                        left: "-30%",
                                    }
                                }
                            }}>
                                {roadmap.thirdYear.filter(({top}) => !top).map((opt, index) => <RoadmapEl
                                    key={"thirdYear-roadmapElBottom-" + index}
                                    top={opt.top}
                                    title={opt.title}
                                    points={opt.points}/>)}
                            </RoadmapElementsContainerRow>
                        </RoadmapElementsContainer>
                    </Box>
                </RoadmapYearsContainer>
                <RoadmapReportsContainer>
                    {reports.map((opt, index) => <RoadmapReportEl
                        key={"RoadmapReportEl-" + index}
                        title={opt.title}
                        description={opt.description}/>
                    )}
                </RoadmapReportsContainer>
            </RoadmapContentContainer>
            {window.innerWidth <= 768 &&  <FileButton title={"Roadmap Table"} file={file} fileTitle={"Insight_Questor_Roadmap"} filePdf={filePDF} size={"small"} />}
        </RoadmapContainer>
    );
};


export default Roadmap;
